import { HttpLink } from 'apollo-link-http';

const uri =
  process.env.NODE_ENV === 'development'
    ? '/graphql'
    : 'https://quora-backend-1988.herokuapp.com/graphql';

const httpLink = new HttpLink({
  uri,
});

export default httpLink;
